import { render, staticRenderFns } from "./MarketSelect.vue?vue&type=template&id=11011b89&scoped=true"
import script from "./MarketSelect.vue?vue&type=script&lang=ts"
export * from "./MarketSelect.vue?vue&type=script&lang=ts"
import style0 from "./MarketSelect.vue?vue&type=style&index=0&id=11011b89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11011b89",
  null
  
)

export default component.exports